<script>
import AdminLayout from '@layouts/admin-main'
import AdjustList from '@components/admin/affiliate-adjust-list'

export default {
  page: {
    title: 'Admin::AffiliateAdjustList',
    meta: [{ name: 'description', content: 'Admin::AffiliateAdjustList' }],
  },
  components: { AdminLayout, AdjustList },
}
</script>

<template>
  <AdminLayout>
    <AdjustList></AdjustList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
